export default __webpack_public_path__ + "static/media/baggage.1d5a5a55.svg";